import { useCallback, useRef, useState } from "react"

interface UseSkuSelectionProps {
  products?: any
  initialSaleProp?: Record<string, string>
}

export function useSkuSelection({ products, initialSaleProp = {} }: UseSkuSelectionProps) {
  const [saleProp, setSaleProp] = useState<Record<string, string>>(initialSaleProp)
  const [selectedSkuId, setSelectedSkuId] = useState<string>("")
  const selectedIds = useRef<string[]>([])
  const ids = useRef<string[]>([])
  const productHasSkus = !!products?.skus?.length

  const findSelectedSku = useCallback(
    (salePropMap: Record<string, string>) => {
      if (!productHasSkus) return null

      const selectedIds = Object.values(salePropMap).filter(Boolean)

      return products?.skus?.find((sku: any) => {
        let skuPropIds = sku?.skuSaleProps?.map((item: any) => item?.propValueId?.toString())

        if (products?.saleProps?.length) {
          const definedPropIds = products.saleProps.map((sp: any) => sp.propId?.toString())
          skuPropIds = sku?.skuSaleProps
            ?.filter((item: any) => definedPropIds.includes(item?.propId?.toString()))
            .map((item: any) => item?.propValueId?.toString())
        }

        if (selectedIds.length !== skuPropIds?.length) return false

        return selectedIds.every((id: string) => skuPropIds.includes(id))
      })
    },
    [products?.skus, products?.saleProps, productHasSkus]
  )

  const togglePropId = useCallback(
    (propValueId: string, propId: string) => {
      setSaleProp((prev) => {
        const next = { ...prev, [propId]: propValueId }
        selectedIds.current = Object.values(next).filter((id) => id)
        const sku = findSelectedSku(next)
        setSelectedSkuId(sku?.id?.toString() || "")
        return next
      })
    },
    [findSelectedSku]
  )

  const toggleMultiplePropId = (propId: string, parentId: string) => {
    setSaleProp((saleProp) => {
      const newSaleProp = { ...saleProp, [parentId]: propId }
      ids.current = Object.values(newSaleProp)?.filter((id) => id)
      return newSaleProp
    })
  }

  return {
    saleProp,
    setSaleProp,
    selectedSkuId,
    setSelectedSkuId,
    togglePropId,
    toggleMultiplePropId,
    findSelectedSku,
    selectedIds
  }
}
